var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09091 20C4.03909 18.8773 0 14.1109 0 9.09091V3.63636L9.09091 0L18.1818 3.63636V9.09091C18.1818 14.1127 14.1427 18.8773 9.09091 20ZM1.81818 4.54545V9.09091C1.87013 11.1928 2.60942 13.2199 3.92289 14.8617C5.23636 16.5035 7.05164 17.6697 9.09091 18.1818C11.1302 17.6697 12.9455 16.5035 14.2589 14.8617C15.5724 13.2199 16.3117 11.1928 16.3636 9.09091V4.54545L9.09091 1.81818L1.81818 4.54545Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09109 9.09086C10.3463 9.09086 11.3638 8.07333 11.3638 6.81814C11.3638 5.56294 10.3463 4.54541 9.09109 4.54541C7.83589 4.54541 6.81836 5.56294 6.81836 6.81814C6.81836 8.07333 7.83589 9.09086 9.09109 9.09086Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5459 12.7273C4.99383 13.5439 5.6508 14.2269 6.44951 14.7061C7.24822 15.1853 8.15997 15.4436 9.09135 15.4545C10.0227 15.4436 10.9345 15.1853 11.7332 14.7061C12.5319 14.2269 13.1889 13.5439 13.6368 12.7273C13.6141 11.0036 10.5986 10 9.09135 10C7.5759 10 4.56863 11.0036 4.5459 12.7273Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.24cf7973fc37d457f4f59d2d581dfeef.svg";
export { ForwardRef as ReactComponent };